module.exports = "<div\n  class=\"modal-inner\"\n  ng-class=\"{ 'no-actions': vm.noActions() }\">\n  <div class=\"modal-inner-content\" ng-transclude=\"content\"></div>\n  <div class=\"modal-actions\" ng-transclude=\"actions\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fino/ng1-modal/src/modal.html
// module id = 1525
// module chunks = 12